module.exports = __webpack_public_path__ + "static/img/reference pics_AUS pool1.1cd8784a.jpg";